import React from "react";
import EqBarbelSvg from "../../../../../../../common/svgs/equipment/EqBarbelSvg";
import EqBikeSvg from "../../../../../../../common/svgs/equipment/EqBikeSvg";
import EqBodyWeightSvg from "../../../../../../../common/svgs/equipment/EqBodyWeightSvg";
import EqBoxingEquipmentSvg from "../../../../../../../common/svgs/equipment/EqBoxingEquipmentSvg";
import EqCablesSvg from "../../../../../../../common/svgs/equipment/EqCablesSvg";
import EqDumbbellsSvg from "../../../../../../../common/svgs/equipment/EqDumbbellsSvg";
import EqEllipticalSvg from "../../../../../../../common/svgs/equipment/EqEllipticalSvg";
import EqGymEquipmentSvg from "../../../../../../../common/svgs/equipment/EqGymEquipmentSvg";
import EqJumpingRopeSvg from "../../../../../../../common/svgs/equipment/EqJumpingRopeSvg";
import EqKettlebellSvg from "../../../../../../../common/svgs/equipment/EqKettlebellSvg";
import EqPullUpBarSvg from "../../../../../../../common/svgs/equipment/EqPullUpBarSvg";
import EqResistanceBandsSvg from "../../../../../../../common/svgs/equipment/EqResistanceBandsSvg";
import EqRowerSvg from "../../../../../../../common/svgs/equipment/EqRowerSvg";
import EqSuspensionTrainerSvg from "../../../../../../../common/svgs/equipment/EqSuspensionTrainerSvg";
import EqTreadmillSvg from "../../../../../../../common/svgs/equipment/EqTreadmillSvg";
import EqYogaMatSvg from "../../../../../../../common/svgs/equipment/EqYogaMatSvg";

type IconComponent = (props: { fill: string; width?: number; height?: number }) => JSX.Element;

/** Equipment id (EQUIPMENT 1–16) → the mobile glyph, as `getExerciseEquipmentImage` maps them. */
const ICONS: Record<number, IconComponent> = {
  1: EqBarbelSvg,
  2: EqDumbbellsSvg,
  3: EqCablesSvg,
  4: EqKettlebellSvg,
  5: EqGymEquipmentSvg,
  6: EqResistanceBandsSvg,
  7: EqBodyWeightSvg,
  8: EqPullUpBarSvg,
  9: EqYogaMatSvg,
  10: EqSuspensionTrainerSvg,
  11: EqBikeSvg,
  12: EqTreadmillSvg,
  13: EqRowerSvg,
  14: EqEllipticalSvg,
  15: EqJumpingRopeSvg,
  16: EqBoxingEquipmentSvg,
};

type Props = {
  equipment: number;
  fill: string;
  size?: number;
};

/** The equipment glyph; nothing for "None" (0) or an id the table does not know. */
const EquipmentIcon = ({ equipment, fill, size = 24 }: Props) => {
  const Icon = ICONS[equipment];
  if (!Icon) return null;
  return <Icon fill={fill} width={size} height={size} />;
};

export default EquipmentIcon;
